import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { PlatformSettings } from "@/types";

// #235: Effektive Plattform-Settings (DEFAULT überlagert mit Admin-Overrides).
export function usePlatformSettings(): UseQueryResult<PlatformSettings> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.list("platformSettings"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<PlatformSettings>("/platform-settings");
    },
    enabled: !!session,
  });
}
